exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".check-keywords{clear:both}.check-keywords__tags{display:flex;flex-wrap:wrap;list-style:none;padding-left:0}.check-keywords__tags li{background:#5650c5;padding:0 0 0 10px;border-radius:22px;margin-right:3px;margin-bottom:3px;color:#fff;font-size:13px;letter-spacing:.3px;display:flex;align-items:center}.check-keywords__remove-tag{padding:0 6px 0 3px;cursor:pointer;color:#fff!important}.check-keywords .setup__form-field{margin:0 2% 0 0;flex:1}.check-keywords .check-keywords__input{display:flex;align-items:flex-start;align-content:space-between;margin-bottom:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./app/components/checker/keywordTags.scss
// module id = 868
// module chunks = 0